import { gql } from "@apollo/client";

export default gql`
  mutation deleteRatingMutation($ratingId: Int!) {
    deleteRating(ratingId: $ratingId) {
      ok
    }
  }
`;
